<div #editorjs id="printContent"
    class="editorjs-content {{ readOnly ? 'w-full' : 'p-4 min-w-[400px] md:min-w-[550px] lg:min-w-[700px] xl:min-w-[800px]' }} bg-white rounded container">
</div>